module.exports = __webpack_public_path__ + "img/innen1.99cddba3.jpg";